import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {ShopService} from "../../../services/shop/shop.service";
import {ProductBarcode} from "../../../models/shop/productBarcode";
import {TableComponent} from "../../ui/table/table.component";
import {BaseComponent} from "../../base/base.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {Router} from "@angular/router";
import Swal from "sweetalert2";

@Component({
  selector: 'app-shop-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent extends BaseComponent implements OnInit  {

    @Input() productId?: string | undefined | null;
    @ViewChild('barcodeList') shopList: TableComponent | undefined;

    barcode: ProductBarcode = new ProductBarcode();
    productDropdownSettings: any = {};
    companyId: string = localStorage.getItem('wisper_companyId') ?? '';

    constructor(public shopService: ShopService,
                public serviceInjector: Injector,
                public modal: NgxSmartModalService,
                private router: Router) {
        super(serviceInjector);}

    async ngOnInit() {
        this.productDropdownSettings = {
            idField: 'id',
            textField: "name",
            allowSearchFilter: true,
            singleSelection: true
        };
    }

    async ngAfterViewInit() {
        this.shopList?.loadData(`/productBarcodes`, {productId: this.productId}, ((item: any) => new ProductBarcode(item)))
    }

    navigateToEditPage(productId: any, barcodeId: string, pageType?: string){
        const params: {} = {
            productId: productId,
            barcodeId: barcodeId,
            pageType: pageType
        }
        this.router.navigate(['companies/shop/barcode/edit'], {queryParams: params})
    }

    async deleteBarcode(barcodeId: string) {
        this.showSpinner();
        await this.shopService.deleteBarcode(barcodeId).then(
            (response: any) => {
                if (response.success) {
                    Swal.fire({
                        icon: 'success',
                        title: "Barcode eliminato con successo!"
                    });
                }
            }
        ).catch((error: any) => {
            console.error(error)
                Swal.fire({
                    icon: 'error',
                    title: "Errore, non è stato possibile eliminare il barcode"
                });
            }
        )
        this.hideSpinner();
    }

}
